import { translationController } from 'magner';
import ruElLocale from 'element-plus/lib/locale/lang/ru';
import ruCustom from '~/configs/translation/ru';

// eslint-disable-next-line no-shadow
export enum SupportedLanguages {
  RUS = 'ru',
}

const i18n = translationController<SupportedLanguages>({
  mainLanguage: 'ru',
  fallbackLanguage: 'ru',
  languages: {
    ru: 'Русский',
  },
  translation: {
    ru: ruCustom,
  },
  elLocales: {
    ru: ruElLocale,
  },
});

export default i18n;
